import(/* webpackMode: "eager" */ "/codebuild/output/src2907415851/src/app/error.tsx");
